import { useState } from 'react'

interface Props {
  onConfirm: (muteUntil: string | null) => void
  onCancel: () => void
}

const PRESETS = [
  { label: '1 час',    hours: 1 },
  { label: '4 часа',   hours: 4 },
  { label: '8 часов',  hours: 8 },
  { label: '1 день',   hours: 24 },
  { label: '3 дня',    hours: 72 },
  { label: '1 неделя', hours: 168 },
  { label: 'Навсегда', hours: null },
]

export function MuteDialog({ onConfirm, onCancel }: Props) {
  const [custom, setCustom] = useState(false)
  const [customDate, setCustomDate] = useState('')

  const minDate = new Date(Date.now() + 60_000).toISOString().slice(0, 16)

  function pickPreset(hours: number | null) {
    if (hours === null) {
      onConfirm(null)
    } else {
      const until = new Date(Date.now() + hours * 3_600_000).toISOString()
      onConfirm(until)
    }
  }

  function confirmCustom() {
    if (!customDate) return
    onConfirm(new Date(customDate).toISOString())
  }

  return (
    <>
      <div className="fixed inset-0 z-50 bg-black/40" onClick={onCancel} />
      <div className="fixed z-50 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2
                      w-72 bg-bg-primary border border-divider rounded-2xl shadow-2xl overflow-hidden animate-fade-in">
        <div className="px-4 py-3 border-b border-divider">
          <p className="text-txt-primary font-medium text-sm">Отключить уведомления</p>
        </div>

        {!custom ? (
          <>
            {PRESETS.map(({ label, hours }) => (
              <button
                key={label}
                onClick={() => pickPreset(hours)}
                className="w-full text-left px-4 py-2.5 text-sm text-txt-primary hover:bg-bg-hover transition-colors"
              >
                {label}
              </button>
            ))}
            <button
              onClick={() => setCustom(true)}
              className="w-full text-left px-4 py-2.5 text-sm text-accent hover:bg-bg-hover transition-colors"
            >
              Своё время…
            </button>
          </>
        ) : (
          <div className="p-4 flex flex-col gap-3">
            <p className="text-txt-secondary text-xs">Выключить до:</p>
            <input
              type="datetime-local"
              value={customDate}
              onChange={(e) => setCustomDate(e.target.value)}
              min={minDate}
              className="w-full bg-bg-input text-txt-primary text-sm rounded-lg px-3 py-2 outline-none focus:ring-1 focus:ring-accent"
            />
            <div className="flex gap-2">
              <button
                onClick={() => setCustom(false)}
                className="flex-1 py-2 rounded-xl text-sm text-txt-secondary hover:bg-bg-hover transition-colors"
              >
                Назад
              </button>
              <button
                disabled={!customDate}
                onClick={confirmCustom}
                className="flex-1 py-2 rounded-xl text-sm bg-accent text-white hover:bg-blue-500 transition-colors disabled:opacity-40"
              >
                Готово
              </button>
            </div>
          </div>
        )}

        <div className="border-t border-divider">
          <button
            onClick={onCancel}
            className="w-full py-2.5 text-sm text-txt-meta hover:bg-bg-hover transition-colors"
          >
            Отмена
          </button>
        </div>
      </div>
    </>
  )
}
